export const splitClientConfig = {
  core: {
    authorizationKey: process.env.NEXT_PUBLIC_SPLIT_CLIENT_KEY,
    key: "anonymousKey",
    trafficType: "anonymous",
  },
};
